<template>
  <div class="d-flex flex-wrap">
    <job-posting-card
      v-for="(item, key) in items"
      :key="key"
      :jobposting="item"
      class="clickable col-12"
      @click="handleClickOnCard"
    />
  </div>
</template>

<script>
import JobPostingCard from '@/Components/JobPostingCard'
export default {
  name: 'RelatedJobPostingsSection',
  components: { JobPostingCard },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleClickOnCard(id) {
      this.$inertia.get(this.$route('jobposting', { id }))
    },
  },
}
</script>
